
import Vue from 'vue'
import Lottie from 'vue-lottie'
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { badgeSchemas, ScorecardEntity } from '@/entities/scorecard'
import { IResponse } from '@/entities'

@Component<ScorecardBadgeHeading>({
    components: { Lottie },
})
export default class ScorecardBadgeHeading extends Vue {
    public animationData = null
    @Getter public scorecard!: ScorecardEntity
    @Getter public scorecardResponsesMap!: { [value: string]: IResponse[] }
    @Getter public badgeTotalMap!: { [value: string]: { pastMonth; total } }
    @Getter public scorecardOutdated!: boolean
    @Getter public scorecardLoading!: boolean

    @Action public loadScorecard
    @Action public loadResponsesForBadge
    @Action public loadTotalCountForBadge

    public mounted() {
        this.load()
    }

    public async load() {
        if (this.scorecardOutdated) {
            await this.loadScorecard()
        }

        if (!this.badgeTotalMap || !this.badgeTotalMap[this.mapKey]) {
            this.loadTotalCountForBadge({ type: 'positive', value: this.value })
        }

        if (
            !this.scorecardResponsesMap ||
            !this.scorecardResponsesMap[this.mapKey]
        ) {
            await this.loadResponsesForBadge({
                type: 'positive',
                value: this.value,
            })
        }
        if (this.badgeId) {
            this.animationData = (
                await import(
                    `@/assets/img/scorecard/animated/${this.badgeId}.json`
                )
            ).default
        }
    }

    public get value() {
        return this.scorecard.selectedBadge.value
    }

    public get badgeId() {
        return this.scorecard.selectedBadge.badgeId
    }

    public get mapKey() {
        return `${this.value}_positive`
    }

    public get loading() {
        return this.scorecardLoading
    }

    public get badgeLabel() {
        return (
            this.scorecard.badges.positive[this.value].label ||
            (this.badgeId && badgeSchemas[this.badgeId].label) ||
            ''
        )
    }

    public get responses() {
        return (
            (this.scorecardResponsesMap &&
                this.scorecardResponsesMap[this.mapKey]) ||
            []
        )
    }

    public get totalCount() {
        return (
            (this.badgeTotalMap &&
                this.badgeTotalMap[this.mapKey] &&
                this.badgeTotalMap[this.mapKey].total) ||
            0
        )
    }

    public get pastMonthCount() {
        return (
            (this.badgeTotalMap &&
                this.badgeTotalMap[this.mapKey] &&
                this.badgeTotalMap[this.mapKey].pastMonth) ||
            0
        )
    }
}
